// components/QuoteDetailsSkeleton.tsx
import React from "react";

const SkeletonBlock = ({ width = "w-full", height = "h-4" }: { width?: string; height?: string }) => (
    <div className={`bg-slate-200 rounded ${width} ${height} animate-pulse`} />
);

export const QuoteDetailsSkeleton: React.FC = () => {
    return (
        <div className="max-w-7xl mx-auto px-4 py-6 space-y-6">
            {/* Header */}
            <div className="flex justify-between items-center">
                <div className="space-y-2">
                    <SkeletonBlock width="w-40" height="h-6" />
                    <SkeletonBlock width="w-32" height="h-4" />
                </div>
                <div className="flex space-x-2">
                    <SkeletonBlock width="w-28" height="h-10" />
                    <SkeletonBlock width="w-36" height="h-10" />
                </div>
            </div>

            {/* Property Info Card */}
            <div className="bg-white rounded-lg shadow p-6 space-y-4">
                <SkeletonBlock width="w-48" height="h-5" />
                <SkeletonBlock width="w-2/3" height="h-4" />
                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
                    {[...Array(4)].map((_, i) => (
                        <div key={i} className="space-y-2">
                            <SkeletonBlock width="w-32" height="h-3" />
                            <SkeletonBlock height="h-4" />
                        </div>
                    ))}
                </div>
            </div>

            <div className="flex">
                {/* Financial Info Card */}
                <div className="bg-white rounded-lg shadow p-6 space-y-4 w-1/3 mr-4">
                    <SkeletonBlock width="w-40" height="h-4" />
                    <SkeletonBlock width="w-32" height="h-4" />
                </div>

                {/* Client Info Card */}
                <div className="bg-white rounded-lg shadow p-6 space-y-4 w-1/3">
                    <SkeletonBlock width="w-40" height="h-4" />
                    <SkeletonBlock width="w-32" height="h-4" />
                </div>
            </div>
        </div>
    );
};
